import React from 'react'
import imageOne from "../../resource/events/annualceremony/rainretreat/2.png";


const KatinaInstruction = () => {
  return (
    <div className="danaPayment-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>
      <h1 className='font-main dark-gold p-4 mt-4'>Kathina Instructions</h1>

      <div className="poem2 mt-5 p-4">
                <div className="text-left">
                    <p>The Samana life goes beyond worldly ties,</p>
                    <p>Where the reality of life gradually unfolds before our eyes.</p>
                    <p>A simple life with robe and bowl,</p>
                    <p>Renunciation — a decision bold.</p>

                    <p>Every step, every word, every thought,</p>
                    <p>s a lesson of Dhamma, a truth long sought.</p>
                    <p>With endurance and effort, steadfast and true,</p>
                    <p>Peace and joy will come to you.</p>

                </div>
                
            </div>

            <div className="p-4 mt-6 text-center">
    <div className="mt-6 calander-box align-item-center">
            <div className="c-details text-left">
                <h2 className='intro-text '>Contact Details : </h2>
                <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                <p className="font-p">Mr Gamini : 0422 069 359</p>
                <p className="font-p">WhatsApp : 0422 069 359</p>
                <p className="font-p">E-mail : info@bvp.org.au</p>
            </div>
           
        </div>
        </div>

      
      </div>
  )
}

export default KatinaInstruction